<template>
  <skud-brsk-panel />
</template>

<script>
import SkudBrskPanel from '@/views/skud/components/SkudBrskPanel.vue'

export default {
  name: 'SkudBrskPage',
  components: { SkudBrskPanel }
}
</script>
